import type { ColDef, ICellRendererParams } from "ag-grid-community";
import { CheckboxRenderer } from "../../../../controls/ag-grid/components/CheckboxRenderer";
import { GridButtons } from "../../../../controls/buttons/GridButtons";
import ColorCircleRenderer from "../components/ColorPicker/ColorCircleRendered";
import type { DelayCategory } from "../models/CatalogCategory";

const cellStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

type Props = {
  setSelectedRowData: (category: DelayCategory) => void;
  setShowModal: (modal: "create" | "update" | "delete" | "") => void;
  showContextMenu: Function;
};

export const useTableData = ({
  setSelectedRowData,
  setShowModal,
  showContextMenu,
}: Props) => {
  const columnDefs: ColDef[] = [
    {
      field: "DelayCategoryName",
      headerName: "Name",
      flex: 1,
      cellStyle: cellStyle,
      minWidth: 130,
      floatingFilter: false,
    },
    {
      field: "AssetName",
      headerName: "Asset",
      flex: 1,
      cellStyle: cellStyle,
      minWidth: 130,
      floatingFilter: false,
    },
    {
      field: "DelayCategoryColor",
      headerName: "Color",
      sortable: false,
      flex: 1,
      cellRenderer: ColorCircleRenderer,
      cellStyle: cellStyle,
      minWidth: 130,
      floatingFilter: false,
    },
    {
      field: "IsActive",
      headerName: "Is Active",
      minWidth: 20,
      flex: 1,
      cellRenderer: CheckboxRenderer,
      cellStyle: cellStyle,
      floatingFilter: false,
    },
    {
      field: "-",
      cellRenderer: GridButtons,
      cellRendererParams: (params: ICellRendererParams) => ({
        setId: setSelectedRowData,
        id: params.data as DelayCategory,
        setShowEditModal: () => setShowModal("update"),
        setShowDeleteModal: () => setShowModal("delete"),
        showContextMenu: () =>
          showContextMenu(event, params.data, "categoriesContext"),
      }),
      wrapText: false,
      autoHeight: false,
      wrapHeaderText: false,
      headerName: "",
      sortable: false,
      flex: 1,
      maxWidth: 220,
      filter: false,
      autoHeaderHeight: true,
      floatingFilter: false,
    },
  ];

  return { columnDefs };
};
